import { render, staticRenderFns } from "./rezervasyonGuncelle.vue?vue&type=template&id=05b32986&scoped=true&"
import script from "./rezervasyonGuncelle.vue?vue&type=script&lang=js&"
export * from "./rezervasyonGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./rezervasyonGuncelle.vue?vue&type=style&index=0&id=05b32986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b32986",
  null
  
)

export default component.exports